import { CompanyData } from '../../types/CompanyData';

export interface Role {
  roleId: string;
  name: string;
  rights: Rights;
}

export enum AVAILABLE_RIGHTS {
  MANAGE_COMPANIES = 'manageCompanies',
  MANAGE_USERS = 'manageUsers',
  COMPANY_MANAGER = 'companyManager',
  MANAGE_INVENTORY = 'manageInventory',
  MANAGE_POLICIES_READ = 'managePoliciesRead',
  MANAGE_POLICIES_WRITE = 'managePoliciesWrite',
  MANAGE_REPORTS = 'manageReports',
  MANAGE_REMOTE_SHELL = 'manageRemoteShell',
  MANAGE_PLATFORM = 'managePlatform',
}

export enum HIDDEN_RIGHTS {
  MANAGE_MSP_TRIAL_FEATURES = 'manageMspTrialFeatures',
}

export interface Rights {
  [AVAILABLE_RIGHTS.MANAGE_COMPANIES]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_INVENTORY]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_POLICIES_READ]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_POLICIES_WRITE]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_USERS]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_REPORTS]?: boolean;
  [AVAILABLE_RIGHTS.COMPANY_MANAGER]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_PLATFORM]?: boolean;
  [AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL]?: boolean;
}

export const CompanyUserRightsMap = {
  companyManager: [
    AVAILABLE_RIGHTS.COMPANY_MANAGER
  ],
  manageCompanies: [
    AVAILABLE_RIGHTS.MANAGE_COMPANIES
  ],
  manageNetworks: [
    AVAILABLE_RIGHTS.MANAGE_INVENTORY,
    AVAILABLE_RIGHTS.MANAGE_POLICIES_READ,
    AVAILABLE_RIGHTS.MANAGE_POLICIES_WRITE
  ]
}

export interface RightsWithOptions {
  [AVAILABLE_RIGHTS.MANAGE_COMPANIES]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_INVENTORY]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_POLICIES_READ]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_POLICIES_WRITE]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_USERS]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_REPORTS]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.COMPANY_MANAGER]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_PLATFORM]?: {
    checked?: boolean;
    disabled?: boolean;
  };
  [AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL]?: {
    checked?: boolean;
    disabled?: boolean;
  };
}

export interface AccountRoleAndPrivilegesData {
  _id?: string;
  role?: Role;
  companyInfo: CompanyData;
  availableRoles?: Array<AvailableRole>;
}

export interface AvailableRole {
  _id?: string;
  name: string;
  rights: Rights;
}
